import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";

import Box from "@mui/material/Box";
import {
  getMonthlyGiveawayMaster,
  importMonthlyActiveGiveaway,
} from "@/fetch/fetchGiveaway";

import Stack from "@mui/material/Stack";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";

export default function CreateSystemSettingGiftDialog(props) {
  const {
    datetime,
    open,
    onClose,
    setSnackMessage,
    setSnackOpen,
    setSnackSeverity,
    fetchAll,
    productData,
  } = props;

  const [itemLists, setItemLists] = React.useState([]);
  const [selectedM18Value, setSelectedM18Value] = React.useState({
    is_active: "",
  });
  const [formValidation, setFormvalidation] = React.useState({
    is_active: false,
  });

  const getGiveawayMaster = async () => {
    const { data } = await getMonthlyGiveawayMaster();
    if (data.length > 0) {
      setItemLists(data);
    }
  };

  const headers = [
    { label: "M18號碼", key: "m18_product_code" },
    { label: "品牌", key: "item_brand" },
    { label: "產品名稱", key: "item_name" },
    { label: "產品單價價錢", key: "item_unit_price" },
    { label: "is_active", key: "" },
  ];

  const handleShopOnChange = (event) => {
    setSelectedM18Value((prev) => ({
      ...prev,
      ...itemLists[event.target.value],
      is_active: "",
    }));
  };

  const handleActiveChange = (event) => {
    setSelectedM18Value((prev) => {
      let tempActiveValue = false;
      if (event.target.value === "開啟") {
        tempActiveValue = true;
      }
      return (prev = { ...prev, is_active: tempActiveValue });
    });
  };

  const onSubmit = async () => {
    const checkIsDuplicate = () => {
      const obj = productData.find((item) => item.id === selectedM18Value.id);
      return obj ? true : false;
    };

    const checkIsError = () => {
      const isActive =
        ["", 0, " "].some((item) => selectedM18Value.is_active === item) &&
        "請選擇狀態";

      return { isActive };
    };

    const invalid = checkIsError();

    setFormvalidation({
      is_active: invalid.isActive,
    });

    if (invalid.isActive) {
      return false;
    } else if (checkIsDuplicate()) {
      setSnackMessage("記錄已存在");
      setSnackSeverity("error");
      setSnackOpen(true);
    } else {
      try {
        const { data } = await importMonthlyActiveGiveaway(datetime, [
          selectedM18Value,
        ]);
        if (data.length > 0) {
          setSnackMessage("新增成功");
          setSnackSeverity("success");
          setSnackOpen(true);
          fetchAll();
        }
      } catch (err) {
        setSnackMessage("新增失敗");
        setSnackSeverity("error");
        setSnackOpen(true);
      } finally {
        onClose();
      }
    }
  };

  React.useEffect(() => {
    getGiveawayMaster();
  }, []);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setSelectedM18Value({
          is_active: "",
        });
        onClose();
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
    >
      <Box sx={{ mt: 2 }} />
      <DialogTitle>
        <Stack direction="row" justifyContent={"space-between"}>
          新增贈品項目
        </Stack>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 10 }}>
        <Box
          component="form"
          noValidate
          sx={{
            display: "grid",
            gridTemplateColumns: { sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="select-brands-label">M18號碼</InputLabel>
            <Select
              required
              id="brand"
              name="brand"
              label="Brand"
              labelId="select-brands-label"
              value={selectedM18Value.m18_product_code}
              onChange={handleShopOnChange}
            >
              <MenuItem disabled>請選擇</MenuItem>
              {_.map(itemLists, (item, key) => (
                <MenuItem key={key} value={key}>
                  {item.m18_product_code}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {itemLists.length > 0 &&
            Object.keys(itemLists[0])
              .filter((item) => item !== "id" && item !== "time_created")
              .map((item, index) => (
                <FormControl key={index} fullWidth>
                  <TextField
                    disabled={selectedM18Value[item] ? false : true}
                    id={item}
                    name={item}
                    label={headers.find((header) => header.key === item).label}
                    value={selectedM18Value[item] || ""}
                    InputProps={{
                      readOnly: true,
                    }}
                  ></TextField>
                </FormControl>
              ))}
          <FormControl fullWidth>
            <InputLabel
              error={!!formValidation.is_active}
              id="select-brands-label"
            >
              狀態
            </InputLabel>
            <Select
              disabled={selectedM18Value.id ? false : true}
              required
              id="is_active"
              name="is_active"
              label="Brand"
              labelId="select-brands-label"
              defaultValue="請選擇"
              value={
                selectedM18Value.is_active === ""
                  ? "請選擇"
                  : selectedM18Value.is_active === true
                  ? "開啟"
                  : "關閉"
              }
              onChange={handleActiveChange}
            >
              <MenuItem disabled value={"請選擇"}>
                請選擇
              </MenuItem>
              {["開啟", "關閉"].map((item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error={!!formValidation.is_active}>
              {formValidation.is_active}
            </FormHelperText>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setSelectedM18Value({
              is_active: "",
            });
            onClose();
          }}
        >
          取消
        </Button>
        <Button onClick={onSubmit} type="submit">
          新增
        </Button>
      </DialogActions>
    </Dialog>
  );
}
